module.exports = __webpack_public_path__ + "media/images/down-69f435257d0833758074ee81fda979d0.png";